import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const getActivitiesAPI = async (
  { pageIndex, skip },
  isLoading,
  accessJWT
) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      skip: pageIndex + 1,
      limit: skip,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/activities/search`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    consoleLog([parsedResponseData, "response123"]);
    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterActivitiesAPI = async (
  { searchQuery, pageIndex, limit },

  isLoading,
  accessJWT
) => {
  try {
    isLoading(true);

    const body = {
      searchQuery,
      skip: pageIndex + 1,
      limit: limit,
    };

    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/activities/search`,
      encryptData(body),
      config
    );
    consoleLog([response, "res"]);
    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData.data, "searchRes"]);
      consoleLog([
        parsedResponseData.data.pagination?.totalPages,
        "parsedResponseData.data.pagination?.totalPages",
      ]);

      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    if (isLoading) isLoading(false);
    throw new Error("Error fetching data");
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  }
};

export const createOrUpdateActivitiesAPI = async (
  args,
  isLoading,
  accessJWT
) => {
  const API_URL = `${ENDPOINT}/app/v1/activities`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = args?.id
      ? await axios.put(API_URL, encryptData(args), config)
      : await axios.post(API_URL, encryptData(args), config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);

      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error creating/updating activities:", error);
    return null;
  }
};

export const deleteActivitiesAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/activities/${args.id}`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.delete(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error deleting activities:", error);
    return null;
  }
};
